<template>
  <div style="width: 100%; height: 100%">
    <canvas v-show="data.length > 0" ref="chart" id="chart"></canvas>
    <v-row
      v-show="data.length === 0"
      align="center"
      justify="center"
      no-gutters
    >
      <span class="caption">Aucune donnée</span>
    </v-row>
  </div>
</template>

<script>
import Chart from "chart.js";
import moment from "moment";
import { api } from "@/api";
import { mapGetters } from "vuex";
import { round10 } from "round10";
export default {
  name: "ProductChart",
  props: {
    take: {
      required: true
    },
    productFilter: {
      required: true
    },
    start: {
      required: true
    },
    end: {
      required: true
    },
    groupBy: {
      required: true
    },
    loading: {
      type: Boolean
    }
  },
  mounted() {
    this.getData();
    this.createChart();
  },
  computed: {
    ...mapGetters(["getInventoryRecords"])
  },
  data() {
    return {
      data: [],
      production: [],
      productionByHour: [],
      consumption: [],
      consumptionByHour: [],
      records: [],
      chart: undefined
    };
  },
  methods: {
    async getData() {
      if (
        this.start !== null &&
        this.productFilter !== null &&
        this.productFilter !== undefined
      ) {
        try {
          this.$emit("update:loading", true);
          this.records = await api.getComputedInventory({
            product: this.productFilter,
            start:
              this.start != null
                ? moment(this.start)
                    .hours(0)
                    .minutes(0)
                    .format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ")
                : this.start,
            end:
              this.end != null
                ? moment(this.end)
                    .hours(23)
                    .minutes(59)
                    .format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ")
                : this.end
          });
          this.data = await api.getInventoryTransactions({
            product: this.productFilter,
            group: "all",
            start:
              this.start != null
                ? moment(this.start)
                    .hours(0)
                    .minutes(0)
                    .format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ")
                : this.start,
            end:
              this.end != null
                ? moment(this.end)
                    .hours(23)
                    .minutes(59)
                    .format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ")
                : this.end
          });
          this.production = await api.getInventoryTransactions({
            product: this.productFilter,
            waste: false,
            group: "production",
            start:
              this.start != null
                ? moment(this.start)
                    .hours(0)
                    .minutes(0)
                    .format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ")
                : this.start,
            end:
              this.end != null
                ? moment(this.end)
                    .hours(23)
                    .minutes(59)
                    .format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ")
                : this.end
          });
          this.productionByHour = await api.getInventoryTransactions({
            product: this.productFilter,
            waste: false,
            group: "production_by_hour",
            start:
              this.start != null
                ? moment(this.start)
                    .hours(0)
                    .minutes(0)
                    .format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ")
                : this.start,
            end:
              this.end != null
                ? moment(this.end)
                    .hours(23)
                    .minutes(59)
                    .format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ")
                : this.end
          });
          this.consumption = await api.getInventoryTransactions({
            product: this.productFilter,
            group: "consumption",
            start:
              this.start != null
                ? moment(this.start)
                    .hours(0)
                    .minutes(0)
                    .format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ")
                : this.start,
            end:
              this.end != null
                ? moment(this.end)
                    .hours(23)
                    .minutes(59)
                    .format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ")
                : this.end
          });
          this.consumptionByHour = await api.getInventoryTransactions({
            product: this.productFilter,
            group: "consumption_by_hour",
            start:
              this.start != null
                ? moment(this.start)
                    .hours(0)
                    .minutes(0)
                    .format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ")
                : this.start,
            end:
              this.end != null
                ? moment(this.end)
                    .hours(23)
                    .minutes(59)
                    .format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ")
                : this.end
          });
          setTimeout(() => {
            this.updateChart();
          }, 100);
        } finally {
          this.$emit("update:loading", false);
        }
      }
    },
    createChart() {
      const ctx = document.getElementById("chart");
      this.chart = new Chart(ctx, {
        type: "bar",
        data: {
          datasets: [
            {
              type: "scatter",
              pointStyle: "rect",
              radius: 5,
              hitRadius: 2,
              label: "Variation par jour",
              backgroundColor: "#61616155",
              data: this.data.map(x => {
                return { x: x.day, y: Number(x.total) };
              })
            },
            {
              type: "scatter",
              fill: false,
              backgroundColor: "rgba(158,158,158, 0.4)",
              borderColor: "rgba(0,0,0,0.9)",
              radius: 5,
              hitRadius: 2,
              label: "Entrée manuelle",
              data: this.records.map(x => {
                return { x: x.date, y: Number(x.quantity) };
              })
            },
            {
              type: "scatter",
              pointStyle: "rect",
              label: "Consommation par heure",
              backgroundColor: "#C62828",
              data: this.consumptionByHour.map(x => {
                return { x: x.day, y: Number(x.total) };
              })
            },
            {
              label: "Consommation par jour",
              backgroundColor: "#E57373",
              data: this.consumption.map(x => {
                return { x: x.day, y: Number(x.total) };
              })
            },
            {
              type: "scatter",
              pointStyle: "rect",
              label: "Production par heure",
              backgroundColor: "#2E7D32",
              data: this.productionByHour.map(x => {
                return { x: x.day, y: Number(x.total) };
              })
            },
            {
              label: "Production par jour",
              backgroundColor: "#66BB6A",
              data: this.production.map(x => {
                return { x: x.day, y: Number(x.total) };
              })
            },
            {
              type: "line",
              fill: false,
              label: "Consommation moyenne",
              backgroundColor: "#C6282855",
              borderColor: "#C6282855",
              pointRadius: 1,
              data: this.consumption.map(x => {
                const previous = this.consumption.filter(
                  d => moment(d.day).isBefore(moment(x.day)) && d.total != 0
                );
                return {
                  x: x.day,
                  y: round10(
                    previous.map(d => +d.total).reduce((a, b) => a + b, 0) /
                      previous.length,
                    -2
                  )
                };
              })
            },
            {
              type: "line",
              fill: false,
              label: "Consommation limite",
              backgroundColor: "#C6282811",
              borderColor: "#C6282811",
              pointRadius: 0,
              data: this.consumption.map(x => {
                const previous = this.consumption.filter(
                  d => moment(d.day).isBefore(moment(x.day)) && d.total != 0
                );
                const n = previous.length;
                const mean =
                  previous.map(d => +d.total).reduce((a, b) => a + b, 0) / n;
                return {
                  x: x.day,
                  y: round10(
                    mean -
                      2 *
                        Math.sqrt(
                          previous
                            .map(d => +d.total)
                            .map(x => Math.pow(x - mean, 2))
                            .reduce((a, b) => a + b, 0) / n
                        ),
                    -2
                  )
                };
              })
            },
            {
              type: "line",
              fill: false,
              label: "Production moyenne",
              backgroundColor: "#2E7D3255",
              borderColor: "#2E7D3255",
              pointRadius: 1,
              data: this.production.map(x => {
                const previous = this.production.filter(
                  d => moment(d.day).isBefore(moment(x.day)) && d.total != 0
                );
                return {
                  x: x.day,
                  y: round10(
                    previous.map(d => +d.total).reduce((a, b) => a + b, 0) /
                      previous.length,
                    -2
                  )
                };
              })
            },
            {
              type: "line",
              fill: false,
              label: "Production limite",
              backgroundColor: "#2E7D3211",
              borderColor: "#2E7D3211",
              pointRadius: 0,
              data: this.production.map(x => {
                const previous = this.production.filter(
                  d => moment(d.day).isBefore(moment(x.day)) && d.total != 0
                );
                const n = previous.length;
                const mean =
                  previous.map(d => +d.total).reduce((a, b) => a + b, 0) / n;
                return {
                  x: x.day,
                  y: round10(
                    mean +
                      2 *
                        Math.sqrt(
                          previous
                            .map(d => +d.total)
                            .map(x => Math.pow(x - mean, 2))
                            .reduce((a, b) => a + b, 0) / n
                        ),
                    -2
                  )
                };
              })
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: true,
          aspectRatio: 3,
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 10,
              bottom: 10
            }
          },
          legend: {
            position: "left"
          },
          scales: {
            xAxes: [
              {
                stacked: true,
                type: "time",
                ticks: {
                  minRotation: 90,
                  maxRotation: 90,
                  min: moment(this.start)
                    .subtract(1, "d")
                    .toDate(),
                  max: moment(this.end)
                    .add(1, "d")
                    .toDate()
                },
                time: {
                  unit: "day",
                  displayFormats: {
                    day: "MM/D"
                  },
                  tooltipFormat: "lll"
                },
                gridLines: {
                  zeroLineColor: "rgba(0,0,0,0.1)",
                  offsetGridLines: false,
                  display: false
                }
              }
            ],
            yAxes: [
              {
                ticks: {
                  display: false
                },
                gridLines: {
                  color: "rgba(0,0,0,0)"
                }
              }
            ]
          }
        }
      });
    },
    updateChart() {
      this.chart.options.scales.xAxes[0].ticks.min = moment(this.start)
        .subtract(1, "d")
        .toDate();
      this.chart.options.scales.xAxes[0].ticks.max = moment(this.end)
        .add(1, "d")
        .toDate();
      this.chart.data.datasets[0].data = this.data.map(x => {
        return {
          x: moment(x.day)
            .hour(12)
            .toDate(),
          y: Number(x.total)
        };
      });
      this.chart.data.datasets[1].data = this.records.map(x => {
        return { x: x.date, y: Number(x.quantity) };
      });
      this.chart.data.datasets[2].data = this.consumptionByHour.map(x => {
        return { x: x.day, y: Number(x.total) };
      });
      this.chart.data.datasets[3].data = this.consumption.map(x => {
        return {
          x: moment(x.day)
            .hour(12)
            .toDate(),
          y: Number(x.total)
        };
      });
      this.chart.data.datasets[4].data = this.productionByHour.map(x => {
        return { x: x.day, y: Number(x.total) };
      });
      this.chart.data.datasets[5].data = this.production.map(x => {
        return {
          x: moment(x.day)
            .hour(12)
            .toDate(),
          y: Number(x.total)
        };
      });
      this.chart.data.datasets[6].data = this.consumption.map(x => {
        const previous = this.consumption.filter(
          d => moment(d.day).isBefore(moment(x.day)) && d.total != 0
        );
        return {
          x: x.day,
          y: round10(
            previous.map(d => +d.total).reduce((a, b) => a + b, 0) /
              previous.length,
            -2
          )
        };
      });
      this.chart.data.datasets[7].data = this.consumption.map(x => {
        const previous = this.consumption.filter(
          d => moment(d.day).isBefore(moment(x.day)) && d.total != 0
        );
        const n = previous.length;
        const mean = previous.map(d => +d.total).reduce((a, b) => a + b, 0) / n;
        return {
          x: x.day,
          y: round10(
            mean -
              2 *
                Math.sqrt(
                  previous
                    .map(d => +d.total)
                    .map(x => Math.pow(x - mean, 2))
                    .reduce((a, b) => a + b, 0) / n
                ),
            -2
          )
        };
      });
      this.chart.data.datasets[8].data = this.production.map(x => {
        const previous = this.production.filter(
          d => moment(d.day).isBefore(moment(x.day)) && d.total != 0
        );
        return {
          x: x.day,
          y: round10(
            previous.map(d => +d.total).reduce((a, b) => a + b, 0) /
              previous.length,
            -2
          )
        };
      });
      this.chart.data.datasets[9].data = this.production.map(x => {
        const previous = this.production.filter(
          d => moment(d.day).isBefore(moment(x.day)) && d.total != 0
        );
        const n = previous.length;
        const mean = previous.map(d => +d.total).reduce((a, b) => a + b, 0) / n;
        return {
          x: x.day,
          y: round10(
            mean +
              2 *
                Math.sqrt(
                  previous
                    .map(d => +d.total)
                    .map(x => Math.pow(x - mean, 2))
                    .reduce((a, b) => a + b, 0) / n
                ),
            -2
          )
        };
      });
      this.chart.update();
    }
  },
  watch: {
    take(v, oldv) {
      if (v !== oldv) {
        this.getData();
      }
    },
    productFilter(v, oldv) {
      if (v !== oldv) {
        this.getData();
      }
    },
    getUncompletedIntegratedTransactionsLength(v, oldv) {
      if (v !== oldv) {
        this.getData();
      }
    },
    start(v, oldv) {
      if (v !== oldv) {
        this.getData();
      }
    },
    end(v, oldv) {
      if (v !== oldv) {
        this.getData();
      }
    },
    getInventoryRecords: {
      deep: true,
      handler: "getData"
    }
  }
};
</script>

<style></style>
